import type { FC } from 'react';

import { Redirect } from '@xing-com/crate-core-router';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useFeatureSwitch } from '@xing-com/hub';

import { Industries } from './industries';
import { OldIndustries } from './oldIndustries';

export const IndustriesList: FC = () => {
  const { isLoggedIn } = useLoginState();
  const showNewLoggedInOverview = useFeatureSwitch(
    'enable_new_logged_in_companies_overview'
  );

  // Logged out users always see new industries page
  if (!isLoggedIn) {
    return <Industries />;
  }

  // Logged in users: redirect if new overview enabled, show old otherwise
  if (showNewLoggedInOverview) {
    return <Redirect to="/companies" noThrow />;
  }

  return <OldIndustries />;
};
